var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomFieldNumberIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 14,
    viewBox: "0 0 70 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161077",
    "data-name": "Group 161077",
    transform: "translate(-2640 -497)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Number",
    transform: "translate(2662 508)",
    fill: "#0d0d0d",
    fontSize: 12,
    fontFamily: "Silka-Regular, Silka"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Number")), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(2640 497.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dribbble-Light-Preview"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "number_sign-_110_",
    "data-name": "number_sign-[#110]",
    d: "M330.521,7568.535h3.014v-3.014h-3.014Zm7.535-3.014v-1.506h-3.014V7561h-1.507v3.014h-3.014V7561h-1.507v3.014H326v1.506h3.014v3.014H326v1.508h3.014v3.014h1.507v-3.014h3.014v3.014h1.507v-3.014h3.014v-1.508h-3.014v-3.014Z",
    transform: "translate(-326 -7561)",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFieldNumberIcon);
export default __webpack_public_path__ + "static/media/custom-field-number-icon.15631e838e24c9645836a4f0798f221e.svg";
export { ForwardRef as ReactComponent };